<template>
    <!-- Answer -->
    <div>
        <v-checkbox @click="trainingStore.clearQuestionValidationError()"
            v-model="odgovor!.IsSelected"
            :label="odgovor!.Content"
        ></v-checkbox>
    </div>
</template>

<script setup lang="ts">
    import { useTrainingStore, ITrainingAnswer } from "@/app/store/app/user-center-trainings/store";
    import { PropType } from "vue";

    const trainingStore = useTrainingStore();

    const props = defineProps({
        odgovor: {
            type: Object as PropType<ITrainingAnswer>,
            required: true
        }
    });
</script>